module.exports = __webpack_public_path__ + "static/media/tom_cole_pic_1.8547ba72.jpg";